
import { IUnderground } from '@cian/api-models/search-offers/v2/types';
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { MICRODATA_EXPERIMENT_ALL_GROUPS, MICRODATA_EXPERIMENT_NAME } from '../../../experiments/experiment';
import { ELocationTypeId } from '../../../types/offer';
import { IOfferCardContext } from '../../../../shared/offer-card/OfferCard';

import { AddressPathItem, TAddressPathItem } from '../../../common/components/address_path_item';
import { SuggestionAddressPathItem } from '../../../common/components/suggestion_address_path_item';

const styles = require('./index.css');

export interface IAddressProps {
  underground?: IUnderground;
  currentPath: string | undefined;
  suggestionDistancesSeoText: string | undefined;
  qsToUris?: { [key: string]: string; };
  hideDot?: boolean;
}

export class AddressItem extends React.Component<IAddressProps> {

  public context: IOfferCardContext;

  public static contextTypes = {
    api: PropTypes.object,
    experiments: PropTypes.array,
    isSimilar: PropTypes.bool,
    jsonQuery: PropTypes.object,
    offer: PropTypes.object,
    offerHelper: PropTypes.object,
  };

  public render() {
    const { offer, api: { tracking } } = this.context;
    const { underground, qsToUris, suggestionDistancesSeoText, currentPath }  = this.props;
    const { geo, suggestionDistances } = offer;

    if (!geo) {
      return null;
    }

    let isGeoAddressWithMetro = geo.address.find(({ type }) => type === 'metro');

    const cityIndex = geo.address.reduce((cIndex, { locationTypeId }, index) => (
      locationTypeId === ELocationTypeId.City ? index + 1 : cIndex
    ), 1);

    const addressLine = geo.address.map(({ fullName, qs, type }) => ({
      label: fullName,
      qs,
      type: type === 'metro' ? 'metro' : 'address',
      url: qsToUris && qsToUris[qs],
    }));

    /**
     * Если есть underground, но нет метро внутри geo.address,
     * то добавляем метро вручную тут
     */
    if (underground && !isGeoAddressWithMetro) {
      addressLine.splice(cityIndex, 0, {
        label: `м.\u00A0${underground.name}`,
        qs: underground.qs,
        type: 'metro',
        url: qsToUris && qsToUris[underground.qs],
      });
    }

    /**
     * Пытаемся взять гео ID текущей выдачи
     */
    const jsonQueryGeoId = this.getGeoIdConcurrences();

    /**
     * Если в гео карточки уже есть гео запроса из ЧПУ - дополнительно расстояние
     * от текущего гео ЧПУ выводить не нужно
     */
    const geoIdСoncurrences = jsonQueryGeoId
      ? geo.address.find(({ id }) => id === jsonQueryGeoId)
      : false;
    const isVisibleSuggestSeoText = geoIdСoncurrences === undefined;

    const addressString = addressLine
      .map(address => address.label)
      .join(', ');

    const microData = MICRODATA_EXPERIMENT_ALL_GROUPS.includes(this.getExperimentGroup())
      ? {
        itemScope: true,
        itemType: 'http://schema.org/Place',
      }
      : {};

    return (
      <div {...microData} className={styles['address-links']}>
        <span {...{ itemProp: 'name', content: addressString }} />
        {addressLine.map(({ label, qs, type, url }, index) => {
          const item = (
            <div
              key={`address-path-item-${index}`}
              className={styles['link-container']}
              onClick={this.handelAddressPathItemClick}>
              <AddressPathItem
                className={styles['address-link']}
                label={label}
                qs={qs}
                url={url}
                type={type as TAddressPathItem}
                trackAddressClick={tracking && tracking.trackAddressClick}
              />
            </div>
          );

          return [index > 0 && ', ', item];
        })}
        {
          (isVisibleSuggestSeoText && suggestionDistancesSeoText) &&
            <SuggestionAddressPathItem
              currentPath={currentPath}
              text={suggestionDistancesSeoText}
              distance={suggestionDistances}
            />
        }
      </div>
    );
  }

  private handelAddressPathItemClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  }

  private getGeoIdConcurrences() {
    const { jsonQuery } = this.context;

    return jsonQuery.geo && jsonQuery.geo.value.length === 1
    // tslint:disable-next-line:no-any
    ? (jsonQuery.geo.value[0] as any).id
    : undefined;
  }

  private getExperimentGroup() {
    return this.context.experiments.reduce((group, experiment) => {
      if (experiment.name === MICRODATA_EXPERIMENT_NAME) {
        return Number(experiment.abGroup);
      }

      return group;
    }, 0);
  }
}
